import { Button } from '@boostbrothers/web-ui/web';
import { Component, type ReactNode } from 'react';

import GraphicAccessDenied from '~assets/graphics/graphic-access-denied.png';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <main className="w-full h-screen flex items-center justify-center bg-gray-100">
          <section className="w-[420px] bg-white rounded-xl p-6 flex flex-col items-center gap-6">
            <img
              src={GraphicAccessDenied}
              alt="error"
              width={120}
              height={120}
            />
            <div className="text-center">
              <h2 className="text-lg font-bold text-gray-800 mb-2">
                오류가 발생했습니다
              </h2>
              <p className="text-sm text-gray-500">
                예상치 못한 오류가 발생했습니다.
                <br />
                다시 시도해 주세요.
              </p>
            </div>
            <Button
              label="홈으로 돌아가기"
              colorType="gray"
              size="lg"
              className="w-full"
              onClick={this.handleReset}
            />
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
